<template>
  <div class="sign_in wrapper">
    <header class="logo grid-content">
      <img class="logo-img" src="../assets/lightkey_logo.png" alt="LightKey Logo">
      <img class="logo-text" src="../assets/lightimelogo.png" alt="LightKey Logo">
    </header>
    <section class="grid-content">
      <div class="contenedor">
        <form @submit.prevent="getAccess()">
          <div class="form-group">
            <label for="exampleInputEmail1">{{ $t('sessionEmail') }}</label>
            <input
              v-model="user.email"
              type="email"
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              :placeholder="$t('sessionEmailPlaceholder')"
            >
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">{{ $t('sessionPassword') }}</label>
            <input
              v-model="user.password"             
              type="password"
              class="form-control"
              id="exampleInputPassword1"
              :placeholder="$t('sessionPasswordPlaceholder')">

          </div>
          <div class="session-button">
            <a class="forgot--btn" href="/#/forgot-password">{{ $t('sessionForgotPassword') }}</a>                                 
            <button type="submit" class="btn signup--btn">{{ $t('sessionSignInButton') }}</button>
          </div>
        </form>
      </div>
      <div>    <button class="button-flag" v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)"> <flag :iso="entry.flag" v-bind:squared=false /> {{entry.title}} </button></div>
    </section>
    <section class="grid-content footer">
      <img class="footer-img" src="../assets/co-funded-h2020-horiz_en.png" v-if="image==='en'" alt="H2020 Logo">
      <img class="footer-img" src="../assets/co-funded-h2020-horiz_de.png" v-if="image==='de'" alt="H2020 Logo">
      <img class="footer-img" src="../assets/co-funded-h2020-horiz_es.png" v-if="image==='es'" alt="H2020 Logo">
    </section>
  </div>
</template>

<script>
  import i18n from '@/plugins/i18n';

  export default {
    data() {
      return {
        image:"en",
        user:{
          email:"",
          password:""
        },
        languages: [{ 
                      flag: 'gb', 
                      language: 'en', 
                      title: 'English' 
                    },
                    { flag: 'es', 
                      language: 'es', 
                      title: 'Español' },
                    { flag: 'de',
                      language: 'de',
                      title: 'Deutsch'}]
      };
    },
    methods: {
      getAccess (event) {
        console.log("Comprobación de acceso, Actualizada la pagina");
        console.log("El usuario es el siguiente: ",this.user);
      
        this.axios.post('https://lightkey.es:3000/lightime/api/users/auth',this.user)
        .then(response => {
          console.log("correcto", response.data);
          localStorage.setItem("session", JSON.stringify(response.data));
          localStorage.setItem("user_email", this.user.email);
          localStorage.setItem("is_logged",true);

          switch(i18n.locale){
            case "en":
              this.$toastr.s(i18n.messages.en.correctLogin);
              break;
            case "es":
              this.$toastr.s(i18n.messages.es.correctLogin);
              break;
            case "de":
              this.$toastr.s(i18n.messages.de.correctLogin);
              break;
          }    
          this.$router.replace('/dashboard');
        })
        .catch(err => {
          console.log("Algo pasa!");                
          console.log("Login erroneo", err);
          switch(i18n.locale){
            case "en":
              this.$toastr.e(i18n.messages.en.uncorrectLogin);
              break;
            case "es":
              this.$toastr.e(i18n.messages.es.uncorrectLogin);
              break;
            case "de":
              this.$toastr.e(i18n.messages.de.uncorrectLogin);
              break;  
          }
        });    
      },
      changeLocale(locale) {        
        i18n.locale = locale;
        console.log(this.image);
        this.image=locale;
        console.log(this.image);
        localStorage.setItem("language",locale);
      },
      forgotPassword(){
        this.$router.replace('/forg-pass');
      }
    },
    created(){
      localStorage.setItem("language","en");
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contenedor {
  padding: 10% 30px;
  border: 2px solid #4cae4c;
  border-radius: 20px;
}

.logo {
  margin-right: 38px;
  padding: 40px;
}

.logo-img {
  max-width: 200px;
}

.logo-text {
  max-width: 200px;
}

h1 {
  color: #7ab648;
}

.forgot--btn {
  float: left;
  text-decoration: none;
  color: #353d46;
}
.forgot--btn:hover {
  color: #7ab648;
}


a.signup--btn  {
  color:white;
}

.btn {
  background-color: #5cb85c;
  color: white;
  border: 1px solid #4cae4c;
}

.wrapper {
  /* padding: 50px auto; */
  display: grid;
  grid-template-columns: 1fr minmax(200px, 700px) 1fr;
}

@media only screen and (max-width: 430px) {
  .wrapper {
    /* padding: 50px auto; */
    display: grid;
    grid-template-columns: 1fr minmax(200px, 300px) 1fr;
  }
}

.grid-content {
  grid-column: 2/3;
}

.session-button {
  display: flex;
  justify-content: space-between;
}

.footer{
  margin-top: 10%;
}
.footer-img{
  width: 300px;
  height: 60px;
}

.button-flag {    
    padding: 15px;    
    border: 1px solid #4cae4c;
    border-radius: 10px;   
    font-size: 18px;    
    margin: 15px;
}
.button-flag:hover{
    background-color: #4cae4c;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Session.vue